import React, { useState, useContext } from "react";
import { NoScenario, ScenariosList } from "./";
import { ScenarioSection } from "../../context/ScenarioContext";
import { useTranslation } from "react-i18next";
const ScenarioFirstPage = () => {
  const [showScenarios, setShowScenarios] = useState(false);
  const { ShowHideFunction } = useContext(ScenarioSection);
  const { t } = useTranslation();
  return (
    <>
      <div
        className="addScenarioCard bg-white m-auto d-flex
             justify-content-between align-items-center px-3 py-4"
      >
        <div className="text-right">
          <p className="mb-1 fn"> {t("اضافه کردن سناریو")}</p>
          <p className="m-0 fn12">
            {t("شما میتوانید سناریو دلخواه خود را اضافه کنید")}
          </p>
        </div>
        <div
          className="addScenarioIcon d-flex justify-content-center
           align-items-center rounded-circle text-white cursor"
          onClick={() => ShowHideFunction("addPage")}
        >
          +
        </div>
      </div>
      {!showScenarios ? <NoScenario /> : <ScenariosList />}
    </>
  );
};

export { ScenarioFirstPage };
